export default [
  {
    title: 'breadcrumb.wholeSale',
    route: 'list-whole-sale',
    icon: 'UsersIcon',
    resource: 'whole-sale',
    action: 'read',
  },
]
